export let DialogPopupCssVars = /*#__PURE__*/function (DialogPopupCssVars) {
  DialogPopupCssVars["nestedDialogs"] = "--nested-dialogs";
  return DialogPopupCssVars;
}({});